module.exports = __webpack_public_path__ + "img/project_max.3565c9de.svg";